import { Box, BoxProps, Skeleton } from '@mui/material'
import Image from 'next/image'

import { WPMedia } from '@/types'

export type MediaProps = BoxProps &
  WPMedia & {
    size?: 'full' | 'large' | 'medium' | 'thumbnail'
    priority?: boolean
  }

const Media = ({ use_video, image, video, size = 'large', priority, ...props }: MediaProps) => {
  return (
    <Box component="span" position="relative" display="flex" width="100%" height="100%" {...props}>
      {!image?.url && !video?.url ? (
        <Skeleton variant="rectangular" width="100%" height="100%" />
      ) : use_video ? (
        <Box
          component="video"
          loop
          muted
          autoPlay
          playsInline
          poster={image?.url}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            position: 'absolute',
            left: 0,
            top: 0
          }}
        >
          <source src={video?.url} type="video/mp4" />
        </Box>
      ) : (
        <Image
          src={size ? image?.sizes?.[size]?.url : image?.url}
          alt={image?.alt || ''}
          style={{ objectFit: 'cover' }}
          priority={priority}
          loading={priority ? undefined : 'lazy'}
          fill
        />
      )}
    </Box>
  )
}

export default Media
